export enum ChallengeType {
  Email = 'EMAIL',
  TextMessage = 'SMS',
  DocVerify = 'DOC_VERIFY',
  SSNVerify = 'SSN_VERIFY',
}
